import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6 2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1H6V2Zm12 3H6v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5ZM0 15h11v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-7Zm13 0h11v7a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-7ZM1 11a1 1 0 0 0-1 1v1h5v-1a1 1 0 0 0-1-1H1Zm18 1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1h-5v-1ZM14 1a1 1 0 0 0-1 1v1h5V2a1 1 0 0 0-1-1h-3Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconProductConstructor24 = createIcon(IconComponent);